<div class='dialog-content' *ngFor="let group of parametersList">
	<ng-container class="list-item">
		<mat-card [matTooltip]="getLayouts(group)" matTooltipClass="tooltip">
			<mat-checkbox [checked]="group.checked" class="checkbox" (change)="select($event.checked, group.id)"></mat-checkbox>
			<p class="group-name">{{group.name}}</p>
		</mat-card>
	</ng-container>
</div>